import script from "./Report.vue?vue&type=script&setup=true&lang=js"
export * from "./Report.vue?vue&type=script&setup=true&lang=js"

import "./Report.vue?vue&type=style&index=0&id=34e629c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34e629c0"]])

export default __exports__